import st from "lib/utils/index";
import { serializePaymentProfile } from "lib/utils/api/serializers/index";
import { PaymentProfileDecorator } from "lib/decorators/index";
import BaseRepository from "./BaseRepository";

export default new (class PaymentProfilesRepository extends BaseRepository {
  find(id) {
    return this.api
      .get(`/payment_profiles/${id}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((pp) => new PaymentProfileDecorator(pp));
  }

  create(data) {
    return this.api
      .post(`/payment_profiles`, {
        payment_profile: serializePaymentProfile(data),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((pp) => new PaymentProfileDecorator(pp));
  }

  update(data, initialData) {
    return this.api
      .put(`/payment_profiles/${data.id}`, {
        payment_profile: serializePaymentProfile(data, initialData),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((pp) => new PaymentProfileDecorator(pp));
  }

  delete(id) {
    return this.api.delete(`/payment_profiles/${id}`);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/PaymentProfilesRepository.js